"use strict";

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncTransform = void 0;
exports.isSyncTransform = function (transform) {
  return transform.length === 1;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7QUFBQTs7Ozs7QUFZYUEsdUJBQWUsR0FBRyxVQUMzQkMsU0FBcUM7RUFBQSxPQUNDQSxTQUFTLENBQUNDLE1BQU0sS0FBSyxDQUFDO0FBQUEiLCJuYW1lcyI6WyJleHBvcnRzIiwidHJhbnNmb3JtIiwibGVuZ3RoIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==